module.exports = __webpack_public_path__ + "static/media/reedCosme909.2031225f.ico";